import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { LoginSocialBarDefinition, LoginSocialBarCSSVars, LoginSocialBarSiteAssetProps } from './LoginSocialBar'
import { DEFAULT_AVATAR_SVG } from './DefaultAvatar'
import {
	LoginSocialBarIconItemProps,
	LoginSocialBarMenuItemProps,
	ResolvedBasicMenuItem,
} from '@wix/thunderbolt-components-native'
import type { ResolvedCustomMenuItems } from './LoginSocialBar.carmi'
import _ from 'lodash'

const justifyContents = {
	rtl: { left: 'flex-end', right: 'flex-start', center: 'center' },
	ltr: { left: 'flex-start', right: 'flex-end', center: 'center' },
} as const

export const css = withCompInfo<LoginSocialBarCSSVars, LoginSocialBarDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compProps', 'styleProperties', 'compLayout', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compProps, styleProperties, compLayout, siteFonts, isMobileView, isOneDocMigrated }) => {
		const { buttonsDirection, buttonsAlignment, iconSize } = compProps
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }

		return {
			'justify-content': justifyContents[buttonsDirection]?.[buttonsAlignment] ?? 'flex-end',
			direction: buttonsDirection,
			'--icon-size': `${iconSize}px`,
			'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated),
		}
	}
)

const getMenuItem = (item: ResolvedBasicMenuItem): LoginSocialBarMenuItemProps => {
	const { link = {}, label, displayCount } = item as any
	return _.omitBy(
		{
			link,
			label,
			displayCount,
		},
		_.isNil
	) as LoginSocialBarMenuItemProps
}

const getMenuItems = (items: Array<ResolvedBasicMenuItem>, isMobileView: boolean) => {
	// @ts-ignore
	return items.filter((item) => (isMobileView ? item.isVisibleMobile : item.isVisible)).map(getMenuItem)
}

const getIconItems = (items: ResolvedCustomMenuItems, isMobileView: boolean): Array<LoginSocialBarIconItemProps> => {
	return (
		items
			// @ts-ignore
			.filter((item) => (isMobileView ? item.isVisibleMobile : item.isVisible))
			.map((item) => {
				// @ts-ignore
				const svgContent = item.iconRef?.svgId?.content || ''
				const iconSvgContent = svgContent || ''
				return {
					iconSvgContent,
					...getMenuItem(item),
				} as LoginSocialBarIconItemProps
			})
	)
}

export const props = withCompInfo<LoginSocialBarSiteAssetProps, LoginSocialBarDefinition>()(
	// @ts-ignore
	['compProps', 'compData', 'isMobileView', 'skin'],
	// @ts-ignore
	({ compProps, compData, isMobileView, skin }) => {
		const {
			loggedInMember: displayMode,
			loggedOutText,
			logOutText,
			showLoggedInText,
			loggedInText: _loggedInText,
		} = compData as any
		const loggedInText = showLoggedInText ? _loggedInText : ''
		const { iconSize, buttonsDirection: direction } = compProps as any

		const dataMenuItems = compData.menuItemsRef?.menuRef?.items ?? []
		const dataIconItems = compData.iconItemsRef?.menuRef?.items ?? []
		const menuItems = getMenuItems(dataMenuItems, isMobileView)
		const iconItems = getIconItems(dataIconItems, isMobileView)

		const defaultAvatarSvgContent = displayMode !== 'textOnly' ? DEFAULT_AVATAR_SVG : ''
		return {
			skin,
			displayMode,
			loggedOutText,
			logOutText,
			loggedInText,
			iconSize,
			direction,
			useNativeMenu: isMobileView,
			menuItems,
			iconItems,
			defaultAvatarSvgContent,
		}
	}
)
